module.exports = __webpack_public_path__ + "assets/img/be-diamond-alert.5935341e.png";